import {createStore} from '../utilities/storeUtils';
import  _ from 'underscore';
import {productsItemsKeyToArrayOfProductItems} from './relationships';
import {isFalsey, isTruthy} from "../utilities/general";
import AsnDetailStore from "./AsnDetailStore";
// let productItems = {
//   1:  {
//     prdId: 1,
//     itmSku:"perisable date item",
//     prdBatchLotRequired: "",
//     prdBarcodeRequired: "",
//     prdBattery: "true",
//     prdFragile: "true",
//     prdHazardMaterial: "false",
//     prdId: "50",
//     prdName: "asdfa",
//     prdPerishable: "true",
//     shelfLife: "3",
//     prdPolyBagRequired: "",
//     prdSerializationRequired: "",
//     prdShipAlone: ""
//   },
//   2:  {
//     prdId: 2,
//     itmSku:"longer perisable date item",
//     prdBatchLotRequired: "",
//     prdBarcodeRequired: "",
//     prdBattery: "true",
//     prdFragile: "true",
//     prdHazardMaterial: "false",
//     prdId: "50",
//     prdName: "asdfa",
//     prdPerishable: "true",
//     shelfLife: "20",
//     prdPolyBagRequired: "",
//     prdSerializationRequired: "",
//     prdShipAlone: ""
//   }
// };

let productItems = {};

const defaults = {

};

const ProductItemStore = createStore({
  storeEventBaseKey: "product_items",
  normalizr: productsItemsKeyToArrayOfProductItems,
  normalizrKey: "productItems",
  getData(){
    return productItems;
  },
  getDefaults(){
    return defaults;
  },
  getSkus(){
    return _.chain(this.getData()).values().pluck("itmSku").value();
  },
  doesRequireLotNumber(productItem){
    return isTruthy(productItem.prdBatchLotRequired);
  },
  isPerishable(productItem){
    return isTruthy(productItem.prdPerishable);
  },
  isFragile(productItem){
    return isTruthy(productItem.prdFragile);
  },
  needsBarcode(productItem){
    // needs barcode is actually the oposite,
    // the value should be "false" or false
    // for you to need a barcode
    return isFalsey(productItem.prdBarcodeRequired);
  },
  getDataViaAsnDetail(detail){
    return _(this.dataAsArray()).where({itmSku: detail.sku});
  },
  doesSkuExist(val){
    return !!_(this.dataAsArray()).findWhere({itmSku: val});
  },
  addSkuToStore(sku, searchItemURL){
    $.ajax({
        url: searchItemURL,
        type: 'POST',
        dataType: 'json',
        async: false,
        data: {
            _asn_WAR_hcportlet_itmSku: sku
        },
        beforeSend: function () {
            $.blockUI({message: 'Please Wait...'});
        },
        complete: function () {
            $.unblockUI();
        },
        success: function (resp) {
            var item = resp;
            var targetItem = buildProductJson(item);
            const dataAndId = {[targetItem.prdId]: targetItem};
            ProductItemStore.mergeData(dataAndId);
        },
        error: function (xhr, status, error) {
            alert("Error in getting Item details");
        }
    });
  },
  addSkusArrayToStore(skusArray, getItemsBySkusUrl){
    $.ajax({
        url: getItemsBySkusUrl,
        type: 'POST',
        dataType: 'json',
        async: false,
        data: {
            _asn_WAR_hcportlet_itmSkus: skusArray
        },
        beforeSend: function () {
            $.blockUI({message: 'Please Wait...'});
        },
        complete: function () {
            $.unblockUI();
        },
        success: function (resp) {
          _(resp).map((item, rowIdx)=>{
            var targetItem = buildProductJson(item);
            const dataAndId = {[targetItem.prdId]: targetItem};
            ProductItemStore.mergeData(dataAndId);
          });
          AsnDetailStore.emitEvent('change');
        },
        error: function (xhr, status, error) {
            alert("Error in getting Item details");
        }
    });
  }
});

function buildProductJson(item){
  var targetItem = {};
  targetItem.prdId = item.product.prdId;
  targetItem.prdName = item.product.prdName != null ? item.product.prdName : "";
  targetItem.prdBattery = item.product.prdBattery;
  targetItem.prdFragile = item.product.prdFragile;
  targetItem.prdPerishable = item.product.prdPerishable;
  targetItem.itmSku = item.itmSku;
  targetItem.itmCost = item.itmCost != null ? item.itmCost : "0";
  targetItem.prdHazardMaterial = item.product.prdHazardMaterial;
  targetItem.prdShipAlone = item.product.prdShipAlone;
  targetItem.prdPolyBagRequired = item.product.prdPolyBagRequired;
  targetItem.prdSerializationRequired = item.product.prdSerializationRequired;
  targetItem.prdBatchLotRequired = item.product.prdBatchLotRequired;
  targetItem.prdBarcodeRequired = item.product.prdBarcodeMarked;
  targetItem.prdDescription = item.product.prdName != null ? item.product.prdName : "";
  targetItem.shelfLife = item.product.prdShelfLife != null ? item.product.prdShelfLife : "";

  return targetItem;
}


window.ProductItemStore = ProductItemStore;
export default ProductItemStore;



// WEBPACK FOOTER //
// ./src/stores/ProductItemStore.js